export class Correo {
    correo: string;
    asunto: string;
    contenido: string;
}